<div class="ap-sign__native-app--instructions">
    <ap-content key="native-app.instruction.content"></ap-content>
    <ap-content data-bb="native-app-instructions" key="native-app.instructions"></ap-content>
</div>
